export const validInputs = (itemClicked, elem) => {
  if (itemClicked) {
    if (itemClicked.style === 'starCount') {
      if (itemClicked.input === 'star-1') {
        return elem.style === 'header' || elem.input === 'star-2';
      }
      return elem.style === 'header' || elem.input === 'star-1';
    }
    if (itemClicked.style === 'header') {
      if (itemClicked.input === 'header-1') {
        return elem.style === 'starCount' || elem.input === 'header-2' || elem.style === 'titleCenter';
      }
      return elem.style === 'starCount' || elem.input === 'header-1' || elem.style === 'titleCenter';
    }
  }
};
